import { enableProdMode, isDevMode } from '@angular/core';
import { bootstrapApplication } from '@angular/platform-browser';
import * as Sentry from '@sentry/angular';
import { AppComponent } from 'app/app.component';
import { appConfig } from 'app/app.config';
import { environment } from 'environments/environment';

// if (environment.production) {
//     enableProdMode();
// }

// if (!isDevMode()) {
//     Sentry.init({
//         dsn: 'https://97f31b3f0d60c804ff9b33807428d1a6@o4505172191608832.ingest.us.sentry.io/4508716507201536',
//         integrations: [
//             Sentry.browserTracingIntegration(),
//             Sentry.replayIntegration({
//                 blockAllMedia: false,
//                 maskAllInputs: false,
//                 maskAllText: false,
//             }),
//         ],
//         //Tracing
//         tracesSampleRate: 1.0, //  Capture 100% of the transactions
//         // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
//         tracePropagationTargets: [
//             'localhost',
//             /^https:\/\/yourserver\.io\/api/,
//         ],
//         // Session Replay
//         replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
//         replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
//     });
// }

// bootstrapApplication(AppComponent, appConfig).catch((err) =>
//     console.error(err)
// );


Sentry.init({
  dsn: "https://97f31b3f0d60c804ff9b33807428d1a6@o4505172191608832.ingest.us.sentry.io/4508716507201536",
  integrations: [
    // Registers and configures the Tracing integration,
    // which automatically instruments your application to monitor its
    // performance, including custom Angular routing instrumentation
    Sentry.browserTracingIntegration(),
    // Registers the Replay integration,
    // which automatically captures Session Replays
    Sentry.replayIntegration(),
  ],

  // Set tracesSampleRate to 1.0 to capture 100%
  // of transactions for tracing.
  // We recommend adjusting this value in production
  // Learn more at
  // https://docs.sentry.io/platforms/javascript/configuration/options/#traces-sample-rate
  tracesSampleRate: 1.0,

  // Set `tracePropagationTargets` to control for which URLs trace propagation should be enabled
  tracePropagationTargets: ["localhost", /^https:\/\/yourserver\.io\/api/],

  // Capture Replay for 10% of all sessions,
  // plus for 100% of sessions with an error
  // Learn more at
  // https://docs.sentry.io/platforms/javascript/session-replay/configuration/#general-integration-configuration
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,
});

bootstrapApplication(AppComponent, appConfig).catch((err) =>
  console.error(err)
);

